export const generateLegalServiceSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "LegalService",
    "name": "Laginestra Advogados",
    "description": "Laginestra Advogados oferece planejamento e defesa previdenciária em linguagem simples para quem não pode errar com o INSS. Atendimento especializado em aposentadoria, benefícios e revisão previdenciária em todo o Brasil.",
    "url": siteUrl,
    "logo": "https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/b26c0d0f98329fdab3976c6a0e236b7f.png",
    "image": "https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/b26c0d0f98329fdab3976c6a0e236b7f.png",
    "telephone": "+55-11-99999-9999",
    "email": "contato@laginestra.com.br",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rua Exemplo, 123",
      "addressLocality": "São Paulo",
      "addressRegion": "SP",
      "postalCode": "01000-000",
      "addressCountry": "BR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "-23.5505",
      "longitude": "-46.6333"
    },
    "openingHours": [
      "Mo-Fr 08:00-18:00"
    ],
    "serviceArea": {
      "@type": "Country",
      "name": "Brasil"
    },
    "priceRange": "$$",
    "areaServed": "Brasil",
    "serviceType": "Direito Previdenciário",
    "knowsAbout": [
      "Direito Previdenciário",
      "Aposentadoria",
      "Benefícios do INSS",
      "Revisão Previdenciária",
      "Planejamento Previdenciário"
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema, null, 2)
      }}
    />
  );
};